import React, { useState } from "react";
import BlogCard from "../../components/public/BlogCard";
import "./BlogPage.css";

/* ── Blog listing ── */
export function BlogPage({ posts, onOpenPost }) {
  const [filter, setFilter] = useState("All");
  const cats     = ["All", ...new Set(posts.map((p) => p.category).filter(Boolean))];
  const filtered = filter === "All" ? posts : posts.filter((p) => p.category === filter);

  return (
    <section style={{ padding: "5rem 2rem" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div className="section-label">Blog</div>
        <h2 className="section-title">All Articles</h2>

        {cats.length > 1 && (
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginBottom: "2rem" }}>
            {cats.map((c) => (
              <button key={c} onClick={() => setFilter(c)} className={`filter-btn ${filter === c ? "active" : ""}`}>{c}</button>
            ))}
          </div>
        )}

        {filtered.length === 0 ? (
          <div className="empty-state"><div className="empty-icon">📰</div><p>No articles published yet.</p></div>
        ) : (
          <div className="card-grid">
            {filtered.map((p) => <BlogCard key={p.id} post={p} onClick={() => onOpenPost(p)} />)}
          </div>
        )}
      </div>
    </section>
  );
}

/* ── Single article ── */
export function BlogArticle({ post, onBack }) {
  return (
    <article className="blog-article fade-up">
      <button className="back-btn" onClick={onBack}>← Back to Blog</button>

      {post.coverUrl ? (
        <img src={post.coverUrl} className="article-cover" alt={post.title} />
      ) : (
        <div className="article-cover article-cover--placeholder">📰</div>
      )}

      <div className="article-meta">
        {post.category && <span className="article-cat">{post.category}</span>}
        <span>By {post.author || "Kedrick Scribner"}</span>
        {post.date && <span>{post.date}</span>}
      </div>

      <h1 className="article-title">{post.title}</h1>

      <div
        className="article-body"
        dangerouslySetInnerHTML={{ __html: post.body || "<p>No content yet.</p>" }}
      />
    </article>
  );
}
